import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-caretright",
  "use": "icon-th-caretright-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-caretright\">\n<path d=\"M22.7075 16.7074L12.7075 26.7074C12.6146 26.8004 12.5043 26.8741 12.3829 26.9243C12.2615 26.9746 12.1314 27.0005 12 27.0005C11.8686 27.0005 11.7385 26.9746 11.6171 26.9243C11.4957 26.8741 11.3854 26.8004 11.2925 26.7074C11.1996 26.6145 11.1259 26.5042 11.0756 26.3828C11.0253 26.2614 10.9995 26.1313 10.9995 25.9999C10.9995 25.8686 11.0253 25.7384 11.0756 25.6171C11.1259 25.4957 11.1996 25.3854 11.2925 25.2924L20.5863 15.9999L11.2925 6.70745C11.1049 6.5198 10.9995 6.26531 10.9995 5.99995C10.9995 5.73458 11.1049 5.48009 11.2925 5.29245C11.4801 5.1048 11.7346 4.99939 12 4.99939C12.2654 4.99939 12.5199 5.1048 12.7075 5.29245L22.7075 15.2924C22.8005 15.3853 22.8742 15.4956 22.9246 15.617C22.9749 15.7384 23.0008 15.8685 23.0008 15.9999C23.0008 16.1314 22.9749 16.2615 22.9246 16.3829C22.8742 16.5043 22.8005 16.6146 22.7075 16.7074Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-caretright.svg
// module id = l0xp
// module chunks = 84